module.exports = __webpack_public_path__ + "static/media/modern-room-items.319cd8bb.png";